import { Col, Container, Row } from "react-bootstrap";
import GetQuoteForm from "./form/GetQuoteForm";
import MainHeader from "./MainHeader";
import MainBanner from "./MainBanner";
import PackageDetailCard from "./PackageDetailCard";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import TabsNav from "./tabs/TabsNav";
import OverView from "./tabs/OverView";
import Itinerary from "./tabs/Itinerary";
import Inclusions from "./tabs/Inclusions";
import GettingThere from "./tabs/GettingThere";
import PolicyInfo from "./tabs/PolicyInfo";
import FaqPackage from "./tabs/FaqPackage";
import EnquireForm from "./form/EnquireForm";
import PackageDetailCardSkeleton from "components/common/Skeleton/packages/PackageDetailCardSkeleton";
import OverViewSkeleton from "components/common/Skeleton/packages/OverViewSkeleton";
import Discussion from "./common/Discussion";
import MarkFlagModal from "components/SharedSafari/view/common/MarkFlagModal";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import Disclaimer from "./common/Disclaimer";

const PackageSafariDetails = () => {
  const { tabKey, packageEnquriToggle, packageViewLoading } = useSafariPackagesContext();
  const { reportContentToggle } = useSharedSafariContext();




  return (
    <>
      <MainHeader />

      <section className="safari_wrapper  bg-white pt-sm-4 pt-0">
        <Container fluid="xxl">
          <Row className="my-sm-4 mb-4 packageSfari">
            <Col xs={12}>
              <MainBanner />
              <div className="wrapper-skybgsafri pb-0">
                {packageViewLoading ? (
                  <PackageDetailCardSkeleton />
                ) : (
                  <PackageDetailCard />
                )}
                <TabsNav />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="safari_wrapper margin_bottomfooter ">
        <Container fluid="xxl">
          <Row className="mb-5  mt-4 itenary_tabs px-md-3">
            <Col xxl={9} xl={9} xs={12} className="safartabs position-relative order-1">
              {tabKey === "overview" && (
                <>
                  <div
                    id="home-tab-pane"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                    className="accordion-item mb-4"
                  >
                    {packageViewLoading ? <OverViewSkeleton /> : <OverView />}

                  </div>

                  <Discussion />

                </>
              )}
              {tabKey === "itinerary" && (
                <div
                  id="itenery-tab-pane"
                  role="tabpanel"
                  aria-labelledby="itenery-tab"
                  className="tab-pane accordion-item mb-3"
                >
                  <Itinerary />
                </div>
              )}
              {tabKey === "inclusions" && (
                <div
                  id="profile-tab-pane"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                  className="tab-pane accordion-item mb-3"
                >
                  <Inclusions />
                </div>
              )}
              {tabKey === "getting-there" && (
                <div
                  id="getting-there"
                  role="tabpanel"
                  aria-labelledby="howto-reach"
                  className="tab-pane  accordion-item mb-3 "
                >
                  <GettingThere />
                </div>
              )}
              {/* {tabKey === "accomodation" && (
                <div
                  id="accomodation"
                  role="tabpanel"
                  aria-labelledby="accomodation-tab"
                  className="mb-3"
                >
                  <Accomodation />
                </div>
              )} */}
              {tabKey === "policy-info" && (
                <div
                  id="policy"
                  role="tabpanel"
                  aria-labelledby="policy-tab"
                  className="mb-3"
                >
                  <PolicyInfo />
                </div>
              )}
              {tabKey === "faq" && (
                <div
                  id="faq-tab-pane"
                  role="tabpanel"
                  aria-labelledby="faq-tab"
                  className="tab-pane accordion-item mb-3"
                >
                  <FaqPackage />
                </div>
              )}


            </Col>
            <Col xxl={3} xl={3} xs={12} className="mb-2 pb-2 order-2">
              <div className="request_quote mb-4 position-relative galssset">
                <button
                  className="intested_btn interestBtn "
                  value="#"
                  style={{
                    backgroundColor: "var(--background-primary)",
                    cursor: "default",
                  }}
                >
                  Request Quote
                </button>
                <div className="interst_wrapper p-0 bg-white">
                  <div className="users_profile d-flex gap-3 align-items-center flex-wrap">
                    <GetQuoteForm />
                  </div>
                </div>
                <div className="qoute_write">
                  <h5 className="mb-0">comming soon </h5>
                </div>
              </div>
              <div className="">
                {/* <OperatorRatingSidebar
                  operator={operatorData}
                  reviews={reviewsData}
                  user={user}
                /> */}
              </div>
            </Col>
            <Col xxl={9} xl={9} xs={12} className="order-3">
                  <Disclaimer/>
            </Col>

          </Row>
        </Container>
      </section>
      {reportContentToggle && <MarkFlagModal type="packageReport" />}
      {packageEnquriToggle && <EnquireForm />}
    </>
  );
};

export default PackageSafariDetails;
